
import { Card } from 'element-ui'

export default {
  extends: Card,
}
